(function () {
  'use strict';

  var THRESHOLD = 5000;   /* PKR */
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="1.8"/><circle cx="17.5" cy="18.5" r="1.8"/></svg>';

  function fmt(n) {
    return 'Rs. ' + Math.round(n).toLocaleString('en-US');
  }

  /* ---------- top announcement bar ---------- */
  function bar() {
    if (document.querySelector('.op-ship-bar')) return;
    var wrap = document.querySelector('.t4s-website-wrapper');
    if (!wrap) return;
    var d = document.createElement('div');
    d.className = 'op-ship-bar';
    d.innerHTML = '<span class="op-ship-bar__ico">' + TRUCK + '</span>' +
      'FREE DELIVERY on orders over <b>' + fmt(THRESHOLD) + '</b>' +
      '<span style="opacity:.6"> \u2014 </span>Flat ' + fmt(250) + ' below that';
    wrap.insertBefore(d, wrap.firstChild);
  }

  /* ---------- product page note + live cart progress ---------- */
  function note() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.op-ship-note')) return;
    var btns = document.querySelector('.t4s-product-form__buttons');
    if (!btns) return;

    var n = document.createElement('div');
    n.className = 'op-ship-note';
    n.innerHTML = '<span class="op-ship-note__ico">' + TRUCK + '</span>' +
      '<span data-op-ship-msg>Free delivery on orders over <b>' + fmt(THRESHOLD) + '</b>. ' +
      'Flat <b>' + fmt(250) + '</b> delivery below that.</span>';
    btns.parentNode.insertBefore(n, btns.nextSibling);
    refresh();
  }

  /* ---------- read the live cart and show progress ---------- */
  function refresh() {
    var note = document.querySelector('.op-ship-note');
    if (!note) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = (cart.total_price || 0) / 100;
        var msg = note.querySelector('[data-op-ship-msg]');
        if (!msg) return;

        if (total <= 0) return;   /* empty cart: keep the plain message */

        if (total >= THRESHOLD) {
          note.classList.add('is--free');
          msg.innerHTML = '<b>You have earned FREE delivery.</b> No delivery charge on this order.';
          return;
        }

        var left = THRESHOLD - total;
        var pct = Math.max(4, Math.min(100, (total / THRESHOLD) * 100));
        note.classList.remove('is--free');
        msg.innerHTML = 'Add <b>' + fmt(left) + '</b> more for <b>FREE delivery</b>.' +
          '<span class="op-ship-prog">' +
            '<span class="op-ship-prog__track"><span class="op-ship-prog__fill" style="width:' + pct.toFixed(1) + '%"></span></span>' +
            '<span class="op-ship-prog__txt">' + fmt(total) + ' of ' + fmt(THRESHOLD) + ' in your cart</span>' +
          '</span>';
      })
      .catch(function () { /* leave the static message in place */ });
  }

  function boot() {
    bar();
    note();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      bar(); note();
      if (tries > 12 || document.querySelector('.op-ship-note')) clearInterval(iv);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  window.addEventListener('pageshow', boot);
  /* update the progress bar after any add-to-cart */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button[name="add"], [data-buy-now]') : null;
    if (t) setTimeout(refresh, 900);
  }, true);
})();
